module.exports = __webpack_public_path__ + "assets/109b86582865b3ff1c008618469af64f.mp3";